import { LoadingOverlay } from './LoadingOverlay';

export function Spinner(props) {
  const { visible, text, children, size, borderRadius, overlayWidth, wrapperStyle = {} } = props;

  return (
    <LoadingOverlay
      active={visible}
      spinner
      fadeSpeed={100}
      text={text}
      styles={{
        wrapper: base => ({ ...base, ...wrapperStyle }),
        overlay: base => ({
          ...base,
          color: 'rgba(0, 0, 0, 0.5)',
          position: 'absolute',
          backgroundColor: 'rgba(255, 255, 255, 0.8)',
          borderRadius,
          marginTop: '0px',
          marginLeft: '0px',
          width: overlayWidth || '100%',
        }),
        spinner: base => ({
          ...base,
          width: size || '50px',
          '& svg circle': { stroke: 'rgba(0, 0, 0, 0.5)' },
        }),
      }}
    >
      {children}
    </LoadingOverlay>
  );
}
